// extracted by mini-css-extract-plugin
export var linkText = "_qc-0";